module.exports = __webpack_public_path__ + "img/school.49041151.svg";